export default __webpack_public_path__ + "static/media/301.76d5a0c1.jpg";